<script setup lang="ts">
import FormSection from "@/components/Document/FormSection/FormSection.vue";
import TranslationHighlightsV2 from "@/features/experience-shared/highlights-v2/translation/components/TranslationHighlightsV2.vue";
import { useTranslationImportantInformation } from "./useTranslationImportantInformation";

const fieldStore = useTranslationImportantInformation();
</script>

<template>
  <FormSection :id="fieldStore.id">
    <TranslationHighlightsV2
      v-model:custom-rows="fieldStore.customRows"
      :data-testid="`translation-${fieldStore.id}`"
      :premade-rows="fieldStore.premadeRows"
      :target-country-code="fieldStore.targetCountryCode"
      :readonly="fieldStore.isReadonly"
    />
  </FormSection>
</template>
